"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TextoDestaque;
(function (TextoDestaque) {
    TextoDestaque["AzulMU500"] = "#43A4D1";
    TextoDestaque["AzulMedioMU600"] = "#0172CB";
    TextoDestaque["AzulEscuroMU900"] = "#073654";
    TextoDestaque["LaranjaMU"] = "#F4762A";
    TextoDestaque["BrancoMU50"] = "#FDFDFD";
})(TextoDestaque || (TextoDestaque = {}));
exports.default = TextoDestaque;
